import { Component, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { PartnerService } from '../crud-service';
import { PartnerCrudIndex } from './crud-index';
import { FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { take, firstValueFrom } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { UserService } from '../../users/crud.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { ContractGenerationService } from '../../contracts/services/contract-generation.service';
import { ContractsService } from '../../contracts/crud-service';

@Component({
  selector: 'app-partner-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [
    PartnerService,
    UserService,
    AuthService,
    PermissionService
  ],
})
export class PartnerIndexComponent extends PartnerCrudIndex implements OnInit, OnDestroy {
  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'PARCEIRO',
      name: 'isPartner',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'REPRESENTANTE',
      name: 'isRepresentative',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'CONTADOR',
      name: 'isCounter',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'UNIDADE',
      name: 'isUnit',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'ATIVO',
      name: 'isActive',
      value: 'true',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'CÓDIGO',
      name: 'code',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'DOCUMENTO',
      name: 'document',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'CNPJ',
      name: 'cnpj',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'RAZÃO SOCIAL',
      name: 'companyName',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'NOME FANTASIA',
      name: 'tradingName',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'INSCRIÇÃO ESTADUAL',
      name: 'stateRegistration',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'TELEFONE',
      name: 'phone',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'CELULAR',
      name: 'cellPhone',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'EMAIL',
      name: 'email',
      value: '',
    },
  ];

  constructor(
    public override dialog: MatDialog,
    public override service: PartnerService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    public override usersService: UserService,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService,
    public override permissionService: PermissionService,
    public override contractsService: ContractsService,
    public override contractGenerationService: ContractGenerationService,
    private route: ActivatedRoute
  ) {
    super(
      dialog,
      service,
      toastService,
      mediaObserver,
      usersService,
      router,
      cdr,
      authService,
      permissionService,
      contractsService,
      contractGenerationService
    );

    // Inicializar propriedades
    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'partners';

    // Garantir que as colunas de contrato estejam incluídas
    if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractGenerated')) {
      this.COLUMNS_TO_SHOW_WEB.push('isContractGenerated');
    }

    if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractSigned')) {
      this.COLUMNS_TO_SHOW_WEB.push('isContractSigned');
    }

    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? this.COLUMNS_TO_SHOW_MOBILE
        : this.COLUMNS_TO_SHOW_WEB;

    });
  }

  ngOnInit(): void {
    // Verificar se está retornando de uma criação ou edição com preserveFilter
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const preserveFilter = params['preserveFilter'] === 'true';

      if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractGenerated')) {
        this.COLUMNS_TO_SHOW_WEB.push('isContractGenerated');
      }

      if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractSigned')) {
        this.COLUMNS_TO_SHOW_WEB.push('isContractSigned');
      }

      this.displayedColumns = this.is_mobile ? this.COLUMNS_TO_SHOW_MOBILE : this.COLUMNS_TO_SHOW_WEB;

      if (preserveFilter) {
        // Restaurar o estado do filtro
        this.restoreFilterState(PartnerService, 'partnerParams');

        // Restaurar os valores do formulário
        const storedFormValues = localStorage.getItem('partnerFilterFormValues');
        if (storedFormValues) {
          this.filterFormValues = JSON.parse(storedFormValues);
        }
      } else {
        // Se não estiver preservando filtros, limpar tudo
        localStorage.removeItem('partnerParams');
        localStorage.removeItem('partnerParamsIsAdvancedFilterActive');
        localStorage.removeItem('partnerParamsLastAppliedFilter');
        localStorage.removeItem('partnerFilterFormValues');

        // Redefinir também no serviço estático
        PartnerService.isAdvancedFilterActive = false;
        PartnerService.lastAppliedFilter = null;
        PartnerService.params = { limit: 25, page: 0, filter: '' };

        // Atualizar os parâmetros locais
        this.params = { limit: 25, page: 0, filter: '' };
        this.isAdvancedFilterActive = false;
        this.lastAppliedFilter = null;
        this.filterFormValues = null;
      }

      // Carregar a lista após definir os parâmetros
      this.loadList();
    });
  }

  ngOnDestroy(): void {
    // Salvar o estado do filtro ao sair da página
    this.saveFilterState(PartnerService, 'partnerParams');
    if (this.filterFormValues) {
      localStorage.setItem('partnerFilterFormValues', JSON.stringify(this.filterFormValues));
    }
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);

    // Armazenar valores do formulário para uso posterior
    this.filterFormValues = filterForm.value;
    localStorage.setItem('partnerFilterFormValues', JSON.stringify(this.filterFormValues));

    this.lastAppliedFilter = { ..._filterForm };
    this.isAdvancedFilterActive = true;
    this.saveFilterState(PartnerService, 'partnerParams');

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        const [data, length] = dataWithPagination;
        this.length = length;

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            item['document'] = item.cnpj || item.cpf;
            item['name'] = item.companyName || item.name;
            item['hideEdit'] = !item.allowEdit;
            item['hideDelete'] = !item.allowDelete;
            item['image'] = item.image;
            item.code = `${item.code}`.padStart(4, '0');
            item['isContractGenerated'] = 'LOADING';
            item['isContractSigned'] = 'LOADING';
            return item;
          })
        );

        this.applyClientSideFilter();
        this.updateContractStatus();
      });
  }

  // Sobrescreve a implementação padrão para lidar com a persistência de filtros
  override loadList(): void {
    const storedFilter = localStorage.getItem('partnerParamsLastAppliedFilter');
    const storedIsActive = localStorage.getItem('partnerParamsIsAdvancedFilterActive');

    if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractGenerated')) {
      this.COLUMNS_TO_SHOW_WEB.push('isContractGenerated');
    }

    if (!this.COLUMNS_TO_SHOW_WEB.includes('isContractSigned')) {
      this.COLUMNS_TO_SHOW_WEB.push('isContractSigned');
    }

    this.displayedColumns = this.is_mobile ? this.COLUMNS_TO_SHOW_MOBILE : this.COLUMNS_TO_SHOW_WEB;

    if (storedIsActive === 'true' && storedFilter) {
      this.isAdvancedFilterActive = true;
      this.lastAppliedFilter = JSON.parse(storedFilter);
      this.submitAdvancedFilter({ value: this.lastAppliedFilter } as any);
    } else {
      super.loadList();
    }
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.code) params.code = filter.code;
    else delete params.code;

    if (filter.document) params.document = filter.document;
    else delete params.document;

    if (filter.isActive !== null && filter.isActive !== undefined && filter.isActive !== '') {
      params.isActive = filter.isActive;
    } else {
      params.isActive = true;
    }

    if (filter.isPartner) params.isPartner = filter.isPartner;
    else delete params.isPartner;

    if (filter.isRepresentative) params.isRepresentative = filter.isRepresentative;
    else delete params.isRepresentative;

    if (filter.isCounter) params.isCounter = filter.isCounter;
    else delete params.isCounter;

    if (filter.isUnit) params.isUnit = filter.isUnit;
    else delete params.isUnit;

    // Adicionar novos campos que foram incluídos no filtro
    if (filter.cnpj) params.cnpj = filter.cnpj;
    else delete params.cnpj;

    if (filter.companyName) params.companyName = filter.companyName;
    else delete params.companyName;

    if (filter.tradingName) params.tradingName = filter.tradingName;
    else delete params.tradingName;

    if (filter.stateRegistration) params.stateRegistration = filter.stateRegistration;
    else delete params.stateRegistration;

    if (filter.phone) params.phone = filter.phone;
    else delete params.phone;

    if (filter.cellPhone) params.cellPhone = filter.cellPhone;
    else delete params.cellPhone;

    if (filter.email) params.email = filter.email;
    else delete params.email;

    return params;
  }

  // Implementar o método filter que preserva o valor do campo de pesquisa
  override filter(value: string): void {
    // Armazenar o valor no params
    this.params.filter = value;

    // Salvar no localStorage e no serviço para persistência
    localStorage.setItem('partnerParams', JSON.stringify(this.params));
    PartnerService.params = this.params;

    // Usar o filtro avançado se estiver ativo
    if (this.isAdvancedFilterActive && this.lastAppliedFilter) {
      this.submitAdvancedFilter({ value: this.lastAppliedFilter } as any);
    } else {
      // Carregar lista normalmente
      this.loadList();

      // Garantir que os status de contrato sejam atualizados após o carregamento
      setTimeout(() => {
        this.updateContractStatus();
      }, 300);
    }
  }

  // Método para resetar todos os filtros
  override resetFilter(): void {
    // Limpar valores do formulário
    this.filterFormValues = null;
    localStorage.removeItem('partnerFilterFormValues');

    // Resetar estado de filtros
    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };

    // Limpar dados persistidos
    localStorage.removeItem('partnerParams');
    localStorage.removeItem('partnerParamsIsAdvancedFilterActive');
    localStorage.removeItem('partnerParamsLastAppliedFilter');

    // Resetar também no serviço estático
    PartnerService.isAdvancedFilterActive = false;
    PartnerService.lastAppliedFilter = null;
    PartnerService.params = { limit: 25, page: 0, filter: '' };

    // Criar um novo FormGroup para resetar os valores de todos os campos, incluindo ATIVO
    const resetFields = this.filterFields.map(field => {
      // Especialmente importante para limpar os valores de SLIDE_TOGGLE
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    // Atualizar os campos do filtro com os valores limpos
    this.filterFields = resetFields;

    // Recarregar lista com filtros limpos
    this.loadList();
  }

  // Método herdado da classe base - navegar para acessos de clientes
  public override navigateToCustomerAccess() {
    // Chama o método da classe pai
    super.navigateToCustomerAccess();
  }

  // Sobrescrever o método para navegar com a flag preserveFilter
  override _openEdit($event: any) {
    // Salvar o estado do filtro antes de navegar
    this.saveFilterState(PartnerService, 'partnerParams');
    if (this.filterFormValues) {
      localStorage.setItem('partnerFilterFormValues', JSON.stringify(this.filterFormValues));
    }

    // Navegar incluindo a flag preserveFilter
    this.router.navigate(['partners/edit', $event.id], {
      queryParams: { preserveFilter: 'true' },
      state: { editParams: this.editParams }
    });
  }

  // Sobrescrever o método para navegar com a flag preserveFilter
  override _openNew($event: any) {
    // Salvar o estado do filtro antes de navegar
    this.saveFilterState(PartnerService, 'partnerParams');
    if (this.filterFormValues) {
      localStorage.setItem('partnerFilterFormValues', JSON.stringify(this.filterFormValues));
    }

    // Navegar incluindo a flag preserveFilter
    this.router.navigate(['partners/new'], {
      queryParams: { preserveFilter: 'true' }
    });
  }

  // Método para atualizar status de contratos
  protected updateContractStatus(): void {
    if (!this.dataSource?.data || this.dataSource.data.length === 0) return;

    const promises = this.dataSource.data.map(async (item: any) => {
      try {
        const contractStatus = await firstValueFrom(this.contractsService.getContractsByPartner(item.id));

        if (contractStatus && Array.isArray(contractStatus)) {
          const totalContracts = contractStatus.length;
          const signedContracts = contractStatus.filter(c => c.status === 'signed').length;

          item['isContractGenerated'] = totalContracts > 0 ? 'SIM' : 'NÃO';

          if (totalContracts > 0) {
            if (signedContracts === totalContracts) {
              item['isContractSigned'] = 'SIM';
            } else if (signedContracts > 0) {
              item['isContractSigned'] = `PARCIAL (${signedContracts}/${totalContracts})`;
            } else {
              item['isContractSigned'] = 'NÃO';
            }
          } else {
            item['isContractSigned'] = 'NÃO';
          }
        } else {
          item['isContractGenerated'] = 'NÃO';
          item['isContractSigned'] = 'NÃO';
        }
      } catch (error) {
        item['isContractGenerated'] = 'ERRO';
        item['isContractSigned'] = 'ERRO';
      }
      return item;
    });

    Promise.all(promises).then(processedData => {
      this.dataSource.data = processedData;
      this.applyClientSideFilter();
      this.cdr.detectChanges();
    });
  }

  // Método para aplicar filtro do lado do cliente
  protected override applyClientSideFilter(): void {
    if (!this.dataSource) return;

    if (this.params.filter && this.params.filter.trim() !== '') {
      const filterValue = this.params.filter.toLowerCase();
      this.dataSource.filter = filterValue;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const name = (data.name || '').toLowerCase();
        const document = (data.document || '').toLowerCase();
        const email = (data.email || '').toLowerCase();
        const code = (data.code || '').toLowerCase();
        const isContractGenerated = (data.isContractGenerated || '').toLowerCase();
        const isContractSigned = (data.isContractSigned || '').toLowerCase();

        return name.includes(filter) ||
          document.includes(filter) ||
          email.includes(filter) ||
          code.includes(filter) ||
          isContractGenerated.includes(filter) ||
          isContractSigned.includes(filter);
      };
    }
  }
}
